import { ACTIVE_QUANTITY_UNITS, asQuantityUnit, roundCommercialQuantity } from '../../utils/commercialQuantity';
import type { QuantityUnit } from '../../utils/commercialQuantity';

export type OrderSaleUnit = QuantityUnit;

export interface OrderSaleQuantityInput {
  quantity?: number | string | null;
  unit?: string | null;
  saleUnit?: string | null;
  saleQuantity?: number | string | null;
}

export const SALE_UNITS: readonly OrderSaleUnit[] = ACTIVE_QUANTITY_UNITS;

export const getOrderSaleUnit = (product: OrderSaleQuantityInput | undefined): OrderSaleUnit => {
  const value = String(product?.saleUnit || product?.unit || 'pcs').trim().toLowerCase();
  return asQuantityUnit(value);
};

// Preview-only mirror of backend orderProductValidation.js. Customer-order
// revenue uses the persisted/entered quantity in the selected pricing unit.
// `quantity` remains the physical/logistics amount used by fulfillment.
export const calculateSaleQuantity = (product: OrderSaleQuantityInput | undefined) => {
  const quantity = Number(product?.saleQuantity ?? product?.quantity ?? 0);
  if (!Number.isFinite(quantity) || quantity <= 0) return null;
  return roundCommercialQuantity(quantity);
};

export const getPreviewSaleQuantity = (product: OrderSaleQuantityInput | undefined) => {
  const calculatedSaleQuantity = calculateSaleQuantity(product);
  if (calculatedSaleQuantity !== null) {
    return calculatedSaleQuantity;
  }

  const pieces = Number(product?.quantity ?? 0);
  return Number.isFinite(pieces) ? pieces : 0;
};
